import { lazyLoad } from '@/utils/loadable';
import { LineLoader } from '@/app/components/loader/line-loader';

export const LLMActivityListingPage = lazyLoad(
  () => import('./llm-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const WebhookActivityListingPage = lazyLoad(
  () => import('./webhook-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const ConversationActivityListingPage = lazyLoad(
  () => import('./conversation-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const KnowledgeActivityListingPage = lazyLoad(
  () => import('./knowledge-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const ToolActivityListingPage = lazyLoad(
  () => import('./tool-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const STTActivityListingPage = lazyLoad(
  () => import('./stt-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const TTSActivityListingPage = lazyLoad(
  () => import('./tts-activities'),
  module => module.ListingPage,
  {
    fallback: <LineLoader />,
  },
);

export const MonitoringPage = lazyLoad(
  () => import('./monitoring'),
  module => module.MonitoringPage,
  {
    fallback: <LineLoader />,
  },
);
